export default "__VITE_ASSET__DM8UdW7m__"